import request from '@/utils/request'
const apiPath = '/live/liveManage'
const liveManageApi = {
  // 表情包
  fetchListEmo(data) {
    return request.post(apiPath + '/emo-list', data)
  },
  createEmo(data) {
    return request.post(apiPath + '/emo-save', data)
  },
  deleteBatchEmo(ids) {
    return request.delete(apiPath + '/emo-batchDelete', { data: ids })
  },
  // 主播
  fetchListAnchor(data) {
    return request.post(apiPath + '/anchor-list', data)
  },
  createAnchor(data) {
    return request.post(apiPath + '/anchor-save', data)
  },
  statusBatchAnchor(data) {
    return request.put(apiPath + '/anchor-batchUpdateStatus', data)
  },
  //管理员
  fetchListAdmin(data) {
    return request.post(apiPath + '/admin-list', data)
  },
  createAdmin(data) {
    return request.post(apiPath + '/admin-save', data)
  },
  deleteBatchAdmin(ids) {
    return request.delete(apiPath + '/admin-batchDelete', { data: ids })
  },
  searchUser(data) {
    return request.post(apiPath + '/searchUser', data, { isFormData: 1 })
  },
  //直播
  fetchListLive(data) {
    return request.post(apiPath + '/live-list', data)
  },
  createLive(data) {
    return request.post(apiPath + '/live-create', data)
  },
  deleteBatchLive(ids) {
    return request.delete(apiPath + '/live-batchDelete', { data: ids })
  },
  //直播商品
  fetchListLiveGoods(data) {
    return request.post(apiPath + '/live-goodsAndtuitionList', data, { isFormData: 1 })
  },
  createLiveGoods(data) {
    return request.post(apiPath + '/livegoods-add', data)
  },
  updateLiveGoodsSeton(data) {
    return request.put(apiPath + '/livegoods-seton', data, { isFormData: 1 })
  },
  updateLiveGoodsSetcanBuy(data) {
    return request.put(apiPath + '/livegoods-setcanBuy', data, { isFormData: 1 })
  },
  updateLiveGoodsSetingShowTime(data) {
    return request.put(apiPath + '/livegoods-ingShowTime', data,{ isFormData: 1 })
  },
  updateLiveGoodsSetoff(data) {
    return request.put(apiPath + '/livegoods-setoff', data,{ isFormData: 1 })
  },
  updateLiveGoodsSort(data) {
    return request.put(apiPath + '/livegoods-sort', data, { isFormData: 1 })
  },
  updateLiveGoods(data) {
    return request.post(apiPath + '/livegoods-updateLiveGoods', data)
  },
  deleteLiveGoods(data) {
    return request.delete(apiPath + '/livegoods-delete', { data })
  },
  // 直播商品删除接口 PUT方法
  deleteLiveGoodsById(data) {
    return request.put(apiPath + '/livegoods-delete', data, { isFormData: 1 })
  },
  // 充值活动
  createLiveGoodsActivity(data) {
    return request.post(apiPath + '/livetuition-add', data, { isFormData: false })
  },
  updateLiveActivityShowTime(data) {
    return request.put(apiPath + '/livetuition-ingShowTime', data, { isFormData: 1 })
  },
  updateLiveActivitySetoff(data) {
    return request.put(apiPath + '/livetuition-setoff', data, { isFormData: 1 })
  },
  updateLiveActivitySeton(data) {
    return request.put(apiPath + '/livetuition-seton', data, { isFormData: 1 })
  },
  updateLiveActivitySort(data) {
    return request.put(apiPath + '/livetuition-sort', data, { isFormData: 1 })
  },
  updateLiveTuition(data) {
    return request.put(apiPath + '/livetuition-updateLiveTuition', data, { isFormData: 1 })
  },
  // 直播充值商品删除接口 PUT方法
  deleteLiveTuitionById(data) {
    return request.put(apiPath + '/livetuition-delete', data, { isFormData: 1 })
  },
  // 更新直播状态
  updateLiveState(data) {
    return request.post(apiPath + '/live-updateliveState', data, { isFormData: 1 })
  },
  // 根据ID获取直播详情
  getLiveById(liveId) {
    return request.get(apiPath + '/live-byid', { params: { liveId } })
  },
  // 获取直播观看用户列表
  getLiveLookList(data) {
    return request.post(apiPath + '/live-look-list', data)
  },
  // 禁言/解禁用户
  forbiddenUser(data) {
    return request.post(apiPath + '/live-forbidden', data)
  },
  // 更新虚拟人数
  updateVirtualCount(data) {
    return request.post(apiPath + '/live-lookUserVirtualcount', null, { 
      params: {
        liveId: data.liveId,
        lookUserVirtualcount: data.virtualCount
      }
    })
  },
  // 清除直播商品缓存
  clearLiveGoodsCache(data) {
    return request.post(apiPath + '/live-clearGoodsAndTuitionListCache', null, { 
      params: {
        liveId: data.liveId
      }
    })
  },
  // 获取直播用户统计数据
  fetchLiveStatisticsByUser(data) {
    return request.post(apiPath + '/live-statisticsByUser', data)
  },
  // 获取区域数据
  getAddressTreeList(query) {
    return request.get('/sys/sysAddr/tee', { params: query })
  },
  // 用户活跃度导出
  downloadStatisticsByUser(data) {
    return request.post(apiPath + '/downloadStatisticsByUser', data)
  },
  // 用户活跃度详情导出
  downloadStatisticsByUserDetail(data) {
    return request.post(apiPath + '/downloadStatisticsByUserDetail', data)
  },
  // 用户活跃度详情查询
  fetchLiveStatisticsByUserDetail(data) {
    return request.post(apiPath + '/live-statisticsByUserDetail', data)
  },
  // 直播间观看人数统计
  fetchLiveStatisticsByLive(data) {
    return request.post(apiPath + '/live-statisticsByLive', data)
  },
  // 直播间观看人数汇总统计
  fetchLiveStatisticsSummaryByLive(data) {
    return request.post(apiPath + '/live-statisticsByLive/summary', data)
  },
  // 直播间大区统计
  fetchLiveAreaStatisticsByLive(data) {
    return request.post(apiPath + '/live-statisticsByLive/area', data)
  },
  // 直播间大区统计导出
  downloadStatisticsAreaByLive(data) {
    return request.post(apiPath + '/live-statisticsByLive/area/download', data)
  },
  // 获取所有身份
  getAllIdentity() {
    return request.get(apiPath + '/live-getallidentity')
  },
  // 获取标签列表
  getTag() {
    return request.get(apiPath + '/live-getTag')
  },
  // 直播观看人数导出
  downloadStatisticsByLive(data) {
    return request.post(apiPath + '/downloadStatisticsByLive', data)
  },
  // 设置直播是否在APP显示
  setLiveIsViewApp(data) {
    return request.post(apiPath + '/live-isViewApp', null, {
      params: {
        liveId: data.liveId,
        isViewApp: data.isViewApp
      }
    })
  },
  // 手动推送直播提醒（全员极光推送）
  pushRemind(liveId) {
    return request.post(apiPath + '/live-pushRemind', null, {
      params: { liveId }
    })
  },
}
export default liveManageApi
